import { render, staticRenderFns } from "./WasteCollection.vue?vue&type=template&id=1590b51f&"
import script from "./WasteCollection.vue?vue&type=script&lang=js&"
export * from "./WasteCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports